import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import moment from 'moment';
export default (function ($prop, _ref) {
  var $ = _ref.$,
      $on = _ref.$on,
      $f7 = _ref.$f7;
  var page_name = 'comment';
  var pn = "div[data-name=\"".concat(page_name, "\"]");
  var limit = 15;
  var page = 0,
      totalItems = 0,
      currentDisplay = 0,
      filter = {},
      allowInfinite = false,
      $infiniteLoader,
      $infiniteContent,
      $list;

  var appendRow = function appendRow(row) {
    var actor = Base.getEmployee(row.id_emp)['name'];
    var sentAt = moment(row.sent_at).format(Base.dateTimeFormat);
    var title = '';
    var no_solution = '<div class="no-solution gray-smaller">(Không có đề xuất nào)</div>';
    var solution = '';

    switch (row.category) {
      case 'colleague':
        var victim = Base.getEmployee(row.id_emp_victim)['name'];
        title = "<span class=\"employee-name\">".concat(actor, "</span> g\xF3p \xFD v\u1EC1 <span class=\"employee-name\">").concat(victim, "</span>");
        solution = row.comment_solution !== null && row.comment_solution.trim() !== '' ? "<div class=\"has-solution margin-top-half\">\u0110\u1EC1 xu\u1EA5t: ".concat(row.comment_solution, "</div>") : no_solution;
        break;

      case 'idea':
        title = "T\xE1c gi\u1EA3 <span class=\"employee-name\">".concat(actor, "</span>");
        break;

      case 'other':
        title = "<span class=\"employee-name\">".concat(actor, "</span> g\u1EB7p v\u1EA5n \u0111\u1EC1");
        solution = row.comment_solution !== null && row.comment_solution.trim() !== '' ? "<div class=\"has-solution margin-top-half\">\u0110\u1EC1 xu\u1EA5t: ".concat(row.comment_solution, "</div>") : no_solution;
        break;

      default:
        break;
    }

    var category = Base.AppConsts.commentCategories.find(function (category) {
      return category.id === row.category;
    });
    var $row = $("\n      <div class=\"card margin-half\">\n        <div class=\"card-content card-content-padding padding-half\">\n          <div class=\"row\">\n            <div class=\"col-10 margin-right-half\">\n              <span class=\"comment-category\" style=\"background-color: ".concat(category.color, "\">").concat(category.icon, "</span>\n            </div>\n            <div class=\"col-60 margin-right-half\">\n              ").concat(title, "\n            </div>\n            <div class=\"col-30 text-align-right\">\n              <span class=\"gray-smaller\">").concat(sentAt, "</span>\n            </div>\n          </div>\n          <div class=\"margin-top-half\">\n            ").concat(row.comment, "\n          </div>\n          ").concat(solution, "\n        </div>\n      </div>\n    "));
    return $row;
  };

  var list = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Base.api('Comment', 'paging', {
                page: page,
                limit: limit,
                filter: filter
              });

            case 2:
              rs = _context.sent;
              totalItems = rs.total;

              if (!(rs.rows.length === 0)) {
                _context.next = 7;
                break;
              }

              $infiniteLoader.addClass('display-none');
              return _context.abrupt("return", false);

            case 7:
              currentDisplay += rs.rows.length;
              allowInfinite = true;
              rs.rows.map(function (row) {
                $list.append(appendRow(row));
              });
              if (currentDisplay === totalItems || currentDisplay > totalItems) $infiniteLoader.addClass('display-none');else $infiniteLoader.removeClass('display-none');

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function list() {
      return _ref2.apply(this, arguments);
    };
  }();

  $on('pageAfterIn', function () {
    $infiniteLoader = $(pn + ' .infinite-scroll-preloader');
    $infiniteContent = $(pn + ' .infinite-scroll-content');
    $list = $(pn + ' .comment-list');
    $infiniteContent.on('infinite', function () {
      if (!allowInfinite) return;
      allowInfinite = false;
      page += 1;
      list();
    });
    var interval = setInterval(function () {
      if (Base.initdataLoaded) {
        clearInterval(interval);
        list();
      }
    }, 100);
  }); //End of pageAfterIn
  //Register filter event

  Base.app.off('commentFilterChange').on('commentFilterChange', function (data) {
    page = 0;
    currentDisplay = 0;
    totalItems = 0;
    filter = data;
    $list.html('');
    list();
  });

  var profile = function profile() {
    Base.profile();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="${page_name}">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left"><a href="#" data-panel=".panel-left" class="panel-open" id="menu-bars"><i class="f7-icons icon">bars</i></a></div>
      <div class="title sliding">Góp ý</div>
      <div class="right"><a href="#" @click=${profile}><i class="f7-icons icon">person_circle</i></a></div>
    </div>
  </div>

  <div class="fab fab-right-bottom">
    <a href="/comment-filter-popup/">
      <i class="icon f7-icons" style="font-size: 16px;">search</i>
    </a>
  </div>

  <div class="page-content infinite-scroll-content infinite-scroll-bottom">
    <div class="comment-list">

    </div>
    <div class="preloader infinite-scroll-preloader display-none"></div>
  </div>

</div>
`
    }
    ;
});